import { render, staticRenderFns } from "./Zonaupload.vue?vue&type=template&id=c05cd4ec&"
import script from "./Zonaupload.vue?vue&type=script&lang=js&"
export * from "./Zonaupload.vue?vue&type=script&lang=js&"
import style0 from "./Zonaupload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Zonaupload.vue"
export default component.exports